import { useContext } from 'react';
import { RedlContext } from 'context/REDL/RedlProvider';

export const useRedl = () => {
    const {
        zoom,
        setZoom,
        showRightSidePanel,
        setShowRightSidePanel,
        showLayout,
        setShowLayout,
        hidePreview,
        setHidePreview,
        redlDatabaseStructure,
        toastText,
        setToastText,
        scrollPercentage,
        setScrollPercentage,
        redlMetadataStructure,
        fileTree,
        setFileTree,
        fileTreeLocalStorageName,
        FILE_TREE_CACHE_EXPIRE_TIME
    } = useContext(RedlContext);

    return {
        unDoZoom: (100 / zoom * 100),
        setZoom,
        showRightSidePanel,
        setShowRightSidePanel,
        showLayout,
        setShowLayout,
        hidePreview,
        setHidePreview,
        redlDatabaseStructure,
        toastText,
        setToastText,
        scrollPercentage,
        setScrollPercentage,
        redlMetadataStructure,
        fileTree,
        setFileTree,
        fileTreeLocalStorageName,
        FILE_TREE_CACHE_EXPIRE_TIME
    };
};
